// extracted by mini-css-extract-plugin
export default {"button":"Button_button__l4+Vg","full":"Button_full__c702B","label":"Button_label__pS4Fo","divider":"Button_divider__sUGb8","icon":"Button_icon__bXV1c"};